import { Sound, SoundNoDates } from "@/types/types";

export const stringifyDatesSound = (sound: Sound): SoundNoDates => {
  const { createdAt, ...newSound } = sound;

  const newNewSound = {
    ...newSound,
    createdAtString: createdAt.toString(),
  };

  return newNewSound;
};
